import React, { type ReactNode } from 'react';
import styled from '@emotion/styled';

const ContentsContainer = styled.main`
  flex: 1;
  min-height: 0;
  padding: ${({ theme }) => theme.spacing[6]}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[6]}px;
  overflow-y: auto;
  overflow-x: hidden;
  background: ${({ theme }) => theme.colors.surface.layout.overlay};
`;

interface DefaultContentsProps {
  children: ReactNode;
}

export const DefaultContents: React.FC<DefaultContentsProps> = ({ children }) => {
  return <ContentsContainer>{children}</ContentsContainer>;
};
